export interface DiscountValueInterface {
  discountValue: number;
  label: string;
}

// quick buttons configured for the user; empty slots (0 €) from the admin form are skipped
export const getQuickDiscountValues = (user: any): DiscountValueInterface[] =>
  (user?.discountValues ?? []).filter(({ discountValue }: DiscountValueInterface) => Number(discountValue) > 0);
